<template>
  <ModuleSection title="指令详情">
      <!-- 表单 -->
    <el-form
      ref="submitForm"
      :model="formData"
      :rules="rules"
      label-position="left"
      label-width="180px">
      <div
        class="detail-area">
        <el-form-item
          :label="$t('账号')"
          class="detail-item">
           <el-input v-model="reponseData.accountNo" disabled class="union-field"/>
        </el-form-item>
        <el-form-item
          :label="$t('账户名称')"
          class="detail-item">
          <el-input v-model="reponseData.accountName" disabled class="union-field"/>
        </el-form-item>
        <el-form-item
          :label="$t('币种')"
          class="detail-item">
          <el-input :value="$t($_params.getDisplay('GRB_CURRENCY_TYPE',reponseData.currencyType))" disabled class="union-field"/>
        </el-form-item>
        <!-- 拒绝或者已退汇状态下显示 -->
        <el-form-item
          :label="$t('操作权限')"
          class="detail-item">
          <el-input :value="userRightString" disabled class="union-field"/>
        </el-form-item>
      </div>
      <!-- 账号在详情或者修改页面均不可改 -->
      <el-form-item
        :label="$t('单笔限额')"
        prop="account"
      >
        <el-input :value="$_format.toCashWithComma(reponseData.limitSingle)" disabled class="union-field"/>
      </el-form-item>
      <el-form-item
        :label="$t('日累计限额')"
        :rules="{ required: true }"
        >
          <el-input
            :value="$_format.toCashWithComma(reponseData.limitDay)"
            disabled class="union-field"/>
      </el-form-item>

    </el-form>
      <el-form style="margin-top: 20px">
      <el-form-item
        v-if="refuseMode"
        :label="$t('拒绝原因')">
         <el-input type="textarea" v-model="refuseReason" :maxlength="100" show-word-limt/>
      </el-form-item>
      </el-form>
      <div class="buttons">
          <el-button
            v-if="mode === 'ADMIN' && !refuseMode"
            type="primary"
            class="btn"
            @click="pass()">
            {{ $t('授权通过') }}
          </el-button>
          <el-button
            v-if="mode === 'ADMIN'"
            type="primary"
            class="btn"
            @click="refuse()">
            {{ $t('拒绝') }}
          </el-button>
          <el-button
            v-if="mode === 'ADMIN' && refuseMode"
            class="btn"
            @click="cancel()">
            {{ $t('取消') }}
          </el-button>
          <el-button
            class="btn"
            @click="$router.go(-1)">
            {{ $t('返回') }}
          </el-button>
        </div>

  </ModuleSection>
</template>

<script>
import ModuleSection from '@/components/container/ModuleSection'
import { getOrderDetailOf10700600, orderRefuseOf10700600, orderAcceptOf10700600 } from '../api'
export default {
  components: {
    ModuleSection
  },
  data () {
    return {
      formData: {},
      reponseData: {},
      refuseMode: false,
      refuseReason: ''
    }
  },
  computed: {
    rules () {
      return {
        account: [
          { required: true, trigger: 'blur' }
        ]
      }
    },
    mode () {
      return this.$route.query.mode
    },
    userRightString () {
      const { accountRight } = this.reponseData
      let sUserRight = ''
      if (accountRight) {
        if (accountRight.charAt(0) === '1') { sUserRight += `${this.$t('查询')},` }
        if (accountRight.charAt(1) === '1') { sUserRight += `${this.$t('付款')},` }
        if (accountRight.charAt(2) === '1') { sUserRight += `${this.$t('代发代扣')},` }
        if (accountRight.charAt(3) === '1') { sUserRight += `${this.$t('集团付款')},` }
      }
      if (sUserRight.length > 1) { sUserRight = sUserRight.substring(0, sUserRight.length - 1) }
      return sUserRight
    }
  },
  created () {
    getOrderDetailOf10700600(this.$route.query).then(res => {
      this.reponseData = res
      this.onInit()
    })
  },
  methods: {
    onInit () {
    },
    pass () {
      const params = {
        authResult: '0',
        authRejectReason: this.refuseReason,
        orderFlowNo: this.$route.query.orderFlowNo,
        actionType: this.$route.query.actionType,
        currentBusinessCode: this.$route.query.businessCode,
        authActionType: '10'
      }
      orderAcceptOf10700600(params).then(res => {
        this.$router.push({
          name: 'EnterpriseAuthManageResult',
          query: {
            ...params,
            ...res
          }
        })
      })
    },
    refuse () {
      if (!this.refuseMode) {
        this.refuseMode = true
      } else {
        // 拒绝逻辑
        if (!this.refuseReason.trim()) {
          this.$talert('请填写拒绝原因')
        } else {
          const params = {
            authResult: '1',
            authRejectReason: this.refuseReason,
            orderFlowNo: this.$route.query.orderFlowNo,
            actionType: this.$route.query.actionType,
            currentBusinessCode: this.$route.query.businessCode,
            authActionType: '11'
          }
          orderRefuseOf10700600(params).then(res => {
            this.$router.push({
              name: 'EnterpriseAuthManageResult',
              query: {
                ...params,
                ...res
              }
            })
          })
        }
      }
    },
    cancel () {
      this.refuseMode = false
      this.refuseReason = ''
    },
    selectable () {
      return false
    }
  }

}
</script>

<style lang="less" scoped>
 .union-field {
   width: 400px;
 }
 .buttons {
   display: flex;
   justify-content: center;
   margin-top: 20px;
 }
 .hidden-select-all-table /deep/.el-table__header-wrapper  .el-checkbox  {
    display:none
}
</style>
